module.exports = __webpack_public_path__ + "images/wechat/arrow-black-aed78e733315ec563c92b906116e4eb7.png";